module.exports = __webpack_public_path__ + "assets/img/phone.cfc72f31.png";